import loadClientScripts from './load-client-scripts'

// Vue & axios
import Vue from 'vue'
import { axios } from '../axios-config'

import 'babel-polyfill'

import vuetify from "./vuetify";
import VueElementLoading from 'vue-element-loading'
import "./numeral";

// import VueElementLoading from 'vue-element-loading'

import { createRouter } from './router'
import { createStore } from './store'

// import vueNumeralFilterInstaller from 'vue-numeral-filter'
// import numeral from 'numeral'

import App from './App.vue'
import Noty from 'noty'


// numeral.register('locale', 'id', {
//   delimiters: {
//     thousands: '.',
//     decimal: ','
//   },
//   abbreviations: {
//     thousand: 'ribu',
//     million: 'juta',
//     billion: 'milyar',
//     trillion: 'trilyun'
//   },
//   ordinal: function(number) {
//     return number === 1 ? '' : ''
//   },
//   currency: {
//     symbol: 'Rp. '
//   }
// })

window._token = document.head.querySelector('meta[name="csrf-token"]').content

Vue.component('v-loading', VueElementLoading)

export function createApp() {
  const router = createRouter('umum')
  const store = createStore(window.route)

  /**
   * Server-side settings
   */
  Vue.prototype.$app = window.settings
  Vue.prototype.$http = axios
  Vue.prototype.$app.swal = window.swal

  /**
   * Server-side named routes function router
   */
  Vue.prototype.$app.route = window.route

  Vue.prototype.isEmptyObject = function(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false
    }
    return true
  }

  /**
   * Object to FormData converter
   */
  let objectToFormData = (obj, form, namespace) => {
    let fd = form || new FormData()

    for (let property in obj) {
      if (!obj.hasOwnProperty(property)) {
        continue
      }

      let formKey = namespace ? `${namespace}[${property}]` : property

      if (obj[property] === null) {
        fd.append(formKey, '')
        continue
      }
      if (typeof obj[property] === 'boolean') {
        fd.append(formKey, obj[property] ? '1' : '0')
        continue
      }
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString())
        continue
      }
      if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File)
      ) {
        objectToFormData(obj[property], fd, formKey)
        continue
      }
      fd.append(formKey, obj[property])
    }

    return fd
  }

  Vue.prototype.$app.objectToFormData = objectToFormData

  /**
   * Notifications
   */
  let noty = (type, text) => {
    new Noty({
      layout: 'topCenter',
      theme: 'sunset',
      timeout: 4800,
      text,
      type
    }).show()
  }

  Vue.prototype.$app.noty = {
    alert: text => {
      noty('alert', text)
    },
    success: text => {
      noty('success', text)
    },
    error: text => {
      noty('error', text)
    },
    warning: text => {
      noty('warning', text)
    },
    info: text => {
      noty('info', text)
    }
  }

  Vue.prototype.$app.alert = {
    question: text => {
      window.swal('', text, 'question')
    },
    success: text => {
      window.swal('SUKSES', text, 'success')
    },
    error: text => {
      window.swal('ERROR', text, 'error')
    },
    warning: text => {
      window.swal('PERINGATAN', text, 'warning')
    },
    info: text => {
      window.swal('INFO', text, 'info')
    }
  }

  Vue.prototype.$app.errorAlert = error => {
    if (typeof error == 'string' || error instanceof String) {
      window.swal('ERROR', error, 'error')
      return
    }

    if (error.response) {
      // Not allowed error
      if (error.response.status === 403) {
        window.swal('ERROR', "unuathorized", 'error')
        return
      }

      // Domain error
      if (error.response.data !== undefined) {
        window.swal('ERROR', error.response.data.message, 'error')
        return
      }
    }

    // Generic error
    window.swal('ERROR', 'General Error', 'error')
  }

  Vue.prototype.$app.error = error => {
    if (typeof error == 'string' || error instanceof String) {
      noty('error', error)
      return
    }

    if (error.response) {
      // Not allowed error
      if (error.response.status === 403) {
        noty('error', 'unauthorized')
        return
      }

      // Not allowed error
      if (error.response.status === 422) {
        noty('error', 'Validation Error')
        return
      }

      // Domain error
      if (error.response.data.error !== undefined) {
        noty('error', error.response.data.message)
        return
      }
    }

    // Generic error
    noty('error', 'General Error!')
  }

  const app = new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
  })

  return {
    app
  }
}

//enable chrome devtools
Vue.config.devtools = true

// Vue.config.productionTip = false

// Load Client Scripts
loadClientScripts(createApp)

// Init App
if (document.getElementById('app') !== null) {
  const { app } = createApp()
  app.$mount('#app')
}
